import { createAction } from 'redux-actions';
import { Module } from '../../types/modules';
import { PapiModuleData } from '@wix/da-papi-types';
import { Gruser } from '../../types/papi';

export const fetchModulesSuccess = createAction(
  '@@gruser.MODULES.FETCH.SUCCESS',
  (gruser: Gruser, modules: PapiModuleData[] | undefined) => ({
    gruser,
    modules,
  })
);

export const fetchModuleSuccess = createAction(
  '@@gruser.MODULE.FETCH.SUCCESS',
  (gruser: Gruser, payload: Module) => ({
    ...payload,
    gruser,
  })
);

export interface UpdateModulePayload {
  id: number;
  moduleMeta?: any;
  moduleData?: any;
}
export const updateModule = createAction(
  '@@gruser.MODULE.UPDATE',
  (gruser: Gruser, payload: UpdateModulePayload) => ({
    ...payload,
    gruser,
  })
);

export interface ModuleEndpointPayload {
  id: number;
  path: string;
  method: 'post' | 'get';
  [key: string]: any;
}
export const fetchModuleEndpoint = createAction(
  '@@gruser.MODULE.ENDPOINT.FETCH',
  (gruser: Gruser, payload: ModuleEndpointPayload) => ({
    ...payload,
    gruser,
  })
);

export const fetchModuleEndpointSuccess = createAction(
  '@@gruser.MODULE.ENDPOINT.FETCH.SUCCESS',
  (gruser: Gruser, payload: { id: number; path: string; response: any }) => ({
    ...payload,
    gruser,
  })
);

export const fetchModuleEndpointError = createAction(
  '@@gruser.MODULE.ENDPOINT.FETCH.ERROR',
  (gruser: Gruser, payload: { id: number; path: string; errorDescription: string }) => ({
    ...payload,
    gruser,
  })
);

export const fetchModuleEndpointPurgeData = createAction(
  '@@gruser.MODULE.ENDPOINT.PURGE_DATA',
  (gruser: Gruser, payload: { id: number; path: string }) => ({
    ...payload,
    gruser,
  })
);

export const purgeAllModules = createAction('@@gruser.MODULE.PURGE.ALL', (gruser: Gruser) => ({
  gruser,
}));
